import { useId } from "react";

import { cn } from "@/lib/utils";

export function FacebookIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-[21px] text-white", className)}
      fill="none"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M20.936 10.5c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 4.991 3.657 9.128 8.437 9.878v-6.987H6.834V10.5h2.54V8.297c0-2.506 1.492-3.89 3.776-3.89 1.095 0 2.239.195 2.239.195v2.46h-1.261c-1.242 0-1.63.771-1.63 1.562V10.5h2.774l-.444 2.89h-2.33v6.988c4.78-.75 8.438-4.887 8.438-9.878z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M.936.5h20v20h-20z" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function InstagramIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-[21px] text-white", className)}
      fill="none"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`} fill="currentColor">
        <path d="M10.336.5C7.62.5 7.279.512 6.213.56c-1.065.049-1.791.218-2.428.465a4.902 4.902 0 00-1.77 1.153A4.902 4.902 0 00.86 3.95C.614 4.586.445 5.313.396 6.377.347 7.444.336 7.784.336 10.5s.011 3.056.06 4.123c.049 1.064.218 1.791.465 2.427a4.902 4.902 0 001.153 1.772 4.902 4.902 0 001.771 1.153c.637.247 1.363.416 2.428.465 1.066.048 1.407.06 4.123.06s3.056-.012 4.123-.06c1.064-.049 1.791-.218 2.427-.465a4.901 4.901 0 001.771-1.153 4.902 4.902 0 001.154-1.772c.247-.636.416-1.363.465-2.427.048-1.067.06-1.407.06-4.123s-.012-3.056-.06-4.123c-.049-1.064-.218-1.791-.465-2.427a4.902 4.902 0 00-1.154-1.772 4.901 4.901 0 00-1.77-1.153C16.25.778 15.522.609 14.458.56 13.392.512 13.052.5 10.336.5zm0 1.802c2.67 0 2.986.01 4.04.058.976.045 1.505.207 1.857.344.467.182.8.399 1.15.748.35.35.567.684.748 1.15.137.353.3.882.345 1.857.048 1.055.058 1.37.058 4.041 0 2.67-.01 2.986-.058 4.04-.045.976-.208 1.505-.345 1.858a3.1 3.1 0 01-.748 1.15c-.35.35-.683.566-1.15.748-.352.137-.881.3-1.856.344-1.055.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.041-.058-.975-.045-1.505-.207-1.857-.344a3.097 3.097 0 01-1.15-.748 3.098 3.098 0 01-.748-1.15c-.137-.353-.3-.882-.344-1.857-.048-1.055-.058-1.37-.058-4.041 0-2.67.01-2.986.058-4.04.044-.976.207-1.505.344-1.858.182-.466.398-.8.748-1.15.35-.35.683-.566 1.15-.748.352-.137.882-.3 1.857-.344 1.054-.048 1.37-.058 4.04-.058z" />
        <path d="M10.336 13.834a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667zm0-8.469a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zm6.538-.203a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0z" />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M.336.5h20v20h-20z" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TikTokIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-4.5 text-white", className)}
      viewBox="0 0 18 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.875 5.022a4.47 4.47 0 01-.388-.225 5.447 5.447 0 01-.995-.846 4.695 4.695 0 01-1.122-2.315h.004c-.085-.5-.05-.824-.045-.824H9.95v13.075c0 .175 0 .348-.008.52l-.003.064c0 .01 0 .02-.003.03v.007a2.87 2.87 0 01-1.444 2.278c-.426.243-.909.37-1.4.37a2.861 2.861 0 01-2.851-2.872 2.861 2.861 0 012.852-2.87c.298-.001.594.046.878.138l.004-3.443a6.281 6.281 0 00-4.84 1.416 6.637 6.637 0 00-1.448 1.786c-.142.246-.68 1.235-.746 2.84-.041.91.233 1.854.363 2.244v.009c.082.23.4 1.013.918 1.674.418.53.911.995 1.465 1.382v-.009l.008.009c1.637 1.112 3.452 1.039 3.452 1.039.314-.013 1.366 0 2.561-.566 1.326-.628 2.08-1.564 2.08-1.564a6.496 6.496 0 001.134-1.884 7.056 7.056 0 00.409-2.154V7.394c.04.025.587.386.587.386s.787.505 2.015.833c.881.234 2.068.283 2.068.283V5.54c-.416.046-1.26-.086-2.125-.517z"
        fill="currentColor"
      />
    </svg>
  );
}

export function XIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4 text-white", className)}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.522 6.771L15.48 0h-1.412L8.895 5.88 4.765 0H0l6.247 8.89L0 15.993h1.412l5.461-6.21 4.363 6.21H16l-6.478-9.22zM7.59 8.97l-.633-.885L1.92 1.039h2.168l4.064 5.686.633.885L14.068 15H11.9L7.589 8.97z"
        fill="#fff"
      />
    </svg>
  );
}
